// Imagens da LP, exportadas em WebP a partir dos originais do Projeto Visual.
// Fotos de pessoas têm no máximo 1670px (limite do material recebido): nunca exibir acima de 100%.

import heroPoster from "../../../assets/img/ghExperience/hero-arena.webp";
import heroPoster960 from "../../../assets/img/ghExperience/hero-arena-960.webp";
import heroPosterTall from "../../../assets/img/ghExperience/hero-arena-vertical.webp";
import heroVideo from "../../../assets/img/ghExperience/hero-arena.mp4";
import heroVideoTall from "../../../assets/img/ghExperience/hero-arena-vertical.mp4";
import rooftopPoster from "../../../assets/img/ghExperience/hero-rooftop.webp";
import rooftopPosterTall from "../../../assets/img/ghExperience/hero-rooftop-vertical.webp";
import rooftopVideo from "../../../assets/img/ghExperience/hero-rooftop.mp4";
import rooftopVideoTall from "../../../assets/img/ghExperience/hero-rooftop-vertical.mp4";
import formSalao from "../../../assets/img/ghExperience/form-salao.mp4";
import formSalaoTall from "../../../assets/img/ghExperience/form-salao-vertical.mp4";
import formSalaoPoster from "../../../assets/img/ghExperience/form-salao.webp";
import formSalaoPosterTall from "../../../assets/img/ghExperience/form-salao-vertical.webp";
import formEncontro from "../../../assets/img/ghExperience/form-encontro.mp4";
import formEncontroTall from "../../../assets/img/ghExperience/form-encontro-vertical.mp4";
import formEncontroPoster from "../../../assets/img/ghExperience/form-encontro.webp";
import formEncontroPosterTall from "../../../assets/img/ghExperience/form-encontro-vertical.webp";

import clipRelacionamento from "../../../assets/img/ghExperience/meeting-relacionamento.mp4";
import clipRelacionamentoTall from "../../../assets/img/ghExperience/meeting-relacionamento-vertical.mp4";
import posterRelacionamento from "../../../assets/img/ghExperience/meeting-relacionamento-poster.webp";
import posterRelacionamentoTall from "../../../assets/img/ghExperience/meeting-relacionamento-poster-vertical.webp";
import clipConversa from "../../../assets/img/ghExperience/meeting-conversa.mp4";
import clipConversaTall from "../../../assets/img/ghExperience/meeting-conversa-vertical.mp4";
import posterConversa from "../../../assets/img/ghExperience/meeting-conversa-poster.webp";
import posterConversaTall from "../../../assets/img/ghExperience/meeting-conversa-poster-vertical.webp";
import clipGastronomia from "../../../assets/img/ghExperience/meeting-gastronomia.mp4";
import clipGastronomiaTall from "../../../assets/img/ghExperience/meeting-gastronomia-vertical.mp4";
import posterGastronomia from "../../../assets/img/ghExperience/meeting-gastronomia-poster.webp";
import posterGastronomiaTall from "../../../assets/img/ghExperience/meeting-gastronomia-poster-vertical.webp";
import conceptClip from "../../../assets/img/ghExperience/concept-juntos.mp4";
import conceptClipTall from "../../../assets/img/ghExperience/concept-juntos-vertical.mp4";
import conceptPoster from "../../../assets/img/ghExperience/concept-juntos-poster.webp";
import conceptPosterTall from "../../../assets/img/ghExperience/concept-juntos-poster-vertical.webp";
import conceptRoom from "../../../assets/img/ghExperience/concept-room.mp4";
import conceptRoomPoster from "../../../assets/img/ghExperience/concept-room.webp";
import conceptRoomPosterTall from "../../../assets/img/ghExperience/concept-room-vertical.webp";
import doneClip from "../../../assets/img/ghExperience/done-mesa.mp4";
import doneClipTall from "../../../assets/img/ghExperience/done-mesa-vertical.mp4";
import donePoster from "../../../assets/img/ghExperience/done-mesa.webp";
import donePosterTall from "../../../assets/img/ghExperience/done-mesa-vertical.webp";

import panelConvite1920 from "../../../assets/img/ghExperience/panel-convite-1920.webp";
import panelConvite960 from "../../../assets/img/ghExperience/panel-convite-960.webp";
import panelLed1920 from "../../../assets/img/ghExperience/panel-led-1920.webp";
import panelLed960 from "../../../assets/img/ghExperience/panel-led-960.webp";
import panelKit1920 from "../../../assets/img/ghExperience/panel-kit-1920.webp";
import panelKit960 from "../../../assets/img/ghExperience/panel-kit-960.webp";

// Fotos de tela cheia: versão horizontal (srcset 1200/1670) + recorte vertical dedicado para o celular.
// Abertura: os takes noturnos originais do vídeo "Arena" (16,6–35,9 s), na ordem e com os cortes da edição,
// sem tratamento — as marcas dos eventos (CEOs, Retail, Magalu) ficam visíveis a pedido do cliente, como credibilidade.
// Termina no salão da Experience House e volta ao salão "CEOs", com a mesma luz. A versão vertical recorta o centro.
export const HERO = {
  video: heroVideo,
  videoTall: heroVideoTall,
  poster: {
    src: heroPoster,
    srcSet: `${heroPoster960} 960w, ${heroPoster} 1920w`,
    width: 1920,
    height: 1080,
    mobile: { src: heroPosterTall, width: 810, height: 1440 },
  },
};

// Cena 2: um clipe do evento real da Experience House por tema (horizontal e vertical) + pôster do primeiro quadro.
export const MEETING_CLIPS = [
  { key: "relacionamento", wide: clipRelacionamento, tall: clipRelacionamentoTall, poster: posterRelacionamento, posterTall: posterRelacionamentoTall },
  { key: "conversa", wide: clipConversa, tall: clipConversaTall, poster: posterConversa, posterTall: posterConversaTall },
  { key: "gastronomia", wide: clipGastronomia, tall: clipGastronomiaTall, poster: posterGastronomia, posterTall: posterGastronomiaTall },
];

// Fundos das etapas do formulário: loops lentos do evento real (vai e volta, sem corte), no padrão das outras cenas.
// 1: o salão à noite, esperando os convidados; 2: o salão cheio, convidados conversando (Experiência 24,8–26,1 s);
// 3: o rooftop na hora azul (clipe "Conselho") e 4: o clipe "relacionamento" do Encontro (já no cache do navegador).
export const FORM_BACKDROPS = [
  { video: formSalao, videoTall: formSalaoTall, poster: formSalaoPoster, posterTall: formSalaoPosterTall },
  { video: formEncontro, videoTall: formEncontroTall, poster: formEncontroPoster, posterTall: formEncontroPosterTall },
  { video: rooftopVideo, videoTall: rooftopVideoTall, poster: rooftopPoster, posterTall: rooftopPosterTall },
  { video: clipRelacionamento, videoTall: clipRelacionamentoTall, poster: posterRelacionamento, posterTall: posterRelacionamentoTall },
];

// Cena 1: a multidão do evento real (Experiência, 27,95–29,95 s) em duotone navy/laranja já gravado no arquivo,
// em vai e volta para um loop sem corte. Aparece só por dentro das letras de "JUNTOS.".
// A faixa larga (1920x540) serve ao desktop; a vertical (540x960) à lombada do celular.
export const CONCEPT_CLIP = { wide: conceptClip, tall: conceptClipTall, poster: conceptPoster, posterTall: conceptPosterTall };

// Cena 1, fundo: o salão do jantar à noite (Arena, 22,60–24,46 s), espelhado, desfocado e graduado navy/âmbar no
// próprio arquivo, em vai e volta com desaceleração (8 s, 640x360). As fotos são o primeiro quadro (toque, lombada,
// baixo consumo e quando a página não segura dois vídeos).
export const CONCEPT_ROOM = { wide: conceptRoom, poster: conceptRoomPoster, posterTall: conceptRoomPosterTall };

// Tela final: a mesa posta da Experience House na hora azul (Conselho, 24,10–25,95 s), desfocada no próprio arquivo,
// em câmera lenta e vai e volta: o salão da Experience House, agora esperando o convidado.
export const DONE_TABLE = { wide: doneClip, tall: doneClipTall, poster: donePoster, posterTall: donePosterTall };

// Mockups do evento (págs. 20, 22 e 25), em alta resolução.
export const PANELS = {
  convite: { src: panelConvite1920, srcSet: `${panelConvite960} 960w, ${panelConvite1920} 1920w`, width: 1920, height: 1080 },
  led: { src: panelLed1920, srcSet: `${panelLed960} 960w, ${panelLed1920} 1920w`, width: 1920, height: 1080 },
  kit: { src: panelKit1920, srcSet: `${panelKit960} 960w, ${panelKit1920} 1920w`, width: 1920, height: 1080 },
};
